import { CustomOption } from "core/catalog";
import { InfoIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/design-system/components/ui/tooltip";
import { useCustomOptionTooltip } from "../../hooks";

type CustomOptionLabelProps = {
  customOption: CustomOption;
};

export function CustomOptionLabel({ customOption }: CustomOptionLabelProps) {
  const { hasTooltip } = useCustomOptionTooltip();

  if (!customOption.name) {
    return "";
  }

  if (!hasTooltip(customOption)) {
    return (
      <span className="flex items-center gap-1 capitalize">
        {customOption.name}
        {customOption.price ? (
          <span className="font-medium text-red-500 text-base">
            ( {customOption.priceType === "add" ? "+" : "-"}
            {customOption.price})
          </span>
        ) : null}
        {customOption.required ? <span className="text-red-500">*</span> : null}
      </span>
    );
  }

  return (
    <div className="flex w-fit items-center gap-2">
      <div className="flex items-center gap-1">
        {customOption.name}
        {customOption.required ? <span className="text-red-500">*</span> : null}
      </div>
      <Tooltip>
        <TooltipTrigger className="flex items-center gap-2 capitalize">
          <InfoIcon className="h-4 w-4" />
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="center"
          className="font-jost border-primary-default mb-1 max-w-64 border-2 border-dashed bg-amber-50"
        >
          <p className="text-sm font-medium">{customOption.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
